import React from 'react';
import { FiCheckCircle, FiShield, FiTrendingUp } from 'react-icons/fi';
import ContactForm from './ContactForm';

export default function Hero() {
  return (
    <section className="relative w-full px-4 pb-10 pt-6 sm:px-6 sm:pb-14 lg:px-8 lg:pb-20 lg:pt-8">
      <div className="mx-auto max-w-7xl">
        <div className="overflow-hidden rounded-[36px] border border-[var(--line-soft)] bg-white/80 shadow-[var(--shadow-soft)] backdrop-blur-xl">
          <div className="grid items-start gap-0 lg:grid-cols-[1.15fr,0.85fr]">
            <div className="relative overflow-hidden px-6 py-10 sm:px-10 sm:py-12 lg:px-12 lg:py-14">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(139,189,195,0.18),transparent_35%),linear-gradient(135deg,rgba(255,255,255,0.78),rgba(237,243,248,0.9))]" />
              <div className="relative max-w-3xl">
                <span className="inline-flex items-center gap-2 rounded-full border border-[var(--line-soft)] bg-white/80 px-3 py-1 text-xs font-semibold text-[var(--brand-accent)]">
                  Online cancellation service
                </span>

                <h1 className="mt-6 text-3xl font-extrabold leading-tight text-[var(--brand-ink)] sm:text-4xl lg:text-5xl">
                  CANCEL YOUR SUBSCRIPTION FREE AND IMMEDIATELY THROUGH OUR ONLINE CANCELLATION SERVICE.
                </h1>

                <p className="mt-4 max-w-2xl text-lg leading-8 text-[var(--text-muted)]">
                  Our operators are trained by our partners to answer all your questions quickly and efficiently.
                </p>

                <div className="mt-8 grid gap-4 sm:grid-cols-3">
                  <div className="rounded-[24px] border border-[var(--line-soft)] bg-white/88 p-4">
                    <div className="flex items-center gap-3">
                      <div className="rounded-2xl bg-[var(--surface-3)] p-2 text-[var(--brand-accent)]">
                        <FiCheckCircle className="h-5 w-5" />
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-[var(--brand-ink)]">Simplified support</div>
                        <div className="text-sm text-[var(--text-muted)]">Manage your subscription in one click.</div>
                      </div>
                    </div>
                  </div>

                  <div className="rounded-[24px] border border-[var(--line-soft)] bg-white/88 p-4">
                    <div className="flex items-center gap-3">
                      <div className="rounded-2xl bg-[var(--surface-3)] p-2 text-[var(--brand-accent)]">
                        <FiShield className="h-5 w-5" />
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-[var(--brand-ink)]">Recognized expertise</div>
                        <div className="text-sm text-[var(--text-muted)]">We support partner sites professionally.</div>
                      </div>
                    </div>
                  </div>

                  <div className="rounded-[24px] border border-[var(--line-soft)] bg-white/88 p-4">
                    <div className="flex items-center gap-3">
                      <div className="rounded-2xl bg-[var(--surface-3)] p-2 text-[var(--brand-accent)]">
                        <FiTrendingUp className="h-5 w-5" />
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-[var(--brand-ink)]">Agents at your service</div>
                        <div className="text-sm text-[var(--text-muted)]">Fast and expert responses.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="border-t border-[var(--line-soft)] bg-[linear-gradient(180deg,rgba(18,38,63,0.04),rgba(31,111,120,0.08))] px-4 py-4 sm:px-6 lg:border-l lg:border-t-0 lg:px-8 lg:py-8">
              <div className="mx-auto max-w-md">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
